import UploadDialog from './UploadDialog'
export default UploadDialog
